export default __webpack_public_path__ + "static/media/warning--animal-drawn-vehicles--g1.38f47feb.png";